import React from 'react';

interface IconProps {
  fill: string;
  height: string;
  width: string;
}

function BillsIcon({ fill, height, width }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" viewBox="0 0 18 30">
      <path
        fill={fill}
        d="M10.041 13.167c-3.783-.984-5-2-5-3.584 0-1.816 1.684-3.083 4.5-3.083 2.967 0 4.067 1.417 4.167 3.5h3.684c-.117-2.867-1.867-5.5-5.35-6.35V0h-5v3.6c-3.234.7-5.834 2.8-5.834 6.017 0 3.85 3.184 5.766 7.834 6.883 4.166 1 5 2.467 5 4.017 0 1.15-.817 2.983-4.5 2.983-3.434 0-4.784-1.533-4.967-3.5H.908c.2 3.65 2.934 5.7 6.134 6.383V30h5v-3.583c3.25-.617 5.833-2.5 5.833-5.917 0-4.733-4.05-6.35-7.834-7.333z"
      ></path>
    </svg>
  );
}

export default BillsIcon;
